/* eslint-disable @typescript-eslint/no-namespace */
import { Box, Tab, Tabs } from '@mui/material'
import React, { DOMAttributes, useState, useContext } from 'react'
import TableauEmbeddingWithToken from './TableauEmbeddingWithToken'
import { UserContext } from 'src/providers'

//tableau-viz needs to be wrapper to use it in React
//using Tableau API downloaded from our server was needed to avoid CORS
class TableauWebComponentWrapper extends HTMLElement {
  static get observedAttributes() {
    return ['token', 'url', 'filters']
  }
  
  _token = ''
  _url = ''
  _filters = '{}'
  
  constructor() {
    super()
  }
  
  connectedCallback() {
    const x = this.attributes as any
    const t = x.token?.value || ''
    const url = x.url?.value || ''
    const filtersStr = x.filters?.value || '{}'
    let filters: Record<string, string> = {}
    
    try {
      filters = JSON.parse(filtersStr)
    } catch (e) {
      console.error('Error parsing filters:', e)
      filters = {}
    }
    
    console.log("Token:", t, "URL:", url, "Filters:", filters)
    
    // Create viz-filter elements for each filter
    const filterElements = Object.entries(filters)
      .map(([field, value]) => `<viz-filter field="${field}" value="${value}"></viz-filter>`)
      .join('\n')
    
    this.innerHTML = `<tableau-viz id="tableauViz"
      src=${url}
      toolbar="hidden"
      hide-tabs
      tooltip="no"
      token="${t}">
      ${filterElements}
    </tableau-viz>`
  }
  
  set token(value: string) {
    this._token = value
  }
  
  get token() {
    return this._token
  }
  
  set url(value: string) {
    this._url = value
  }
  
  get url() {
    return this._url
  }

  set filters(value: string) {
    this._filters = value
  }

  get filters() {
    return this._filters
  }
  
  static get tag() {
    return 'tableau-embedding'
  }
}

type CustomElement<T> = Partial<T & DOMAttributes<T> & { children: any }>

declare global {
  namespace JSX {
    interface IntrinsicElements {
      ['tableau-embedding']: CustomElement<TableauWebComponentWrapper>
    }
  }
}

customElements.define(TableauWebComponentWrapper.tag, TableauWebComponentWrapper)


const tableauViews = new Map<string, string>([
  ['Main', 'https://tableau-server.prod.app.exfluency-cloud.com/views/AIPortal/Dashboard1?:origin=card_share_link&:embed=yes&:toolbar=no&:tooltip=no']
])

const BiPage: React.FC = () => {
  const [selectedTab, setSelectedTab] = useState(0)
  const { user } = useContext(UserContext)

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTab(newValue)
  }

  const filters = {
    'Company Charged': user?.company?.companyId || ''
  }

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'center', marginBottom: 2 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Tableau Views Tabs"
          sx={{ display: 'inline-flex' }}
        >
          {[...tableauViews.keys()].map((label, index) => (
            <Tab key={index} label={label} value={index} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ padding: 2 }}>
        {[...tableauViews.entries()].map(([, url], index) => (
          selectedTab === index && (
            <TableauEmbeddingWithToken 
              key={index} 
              url={url} 
              filters={filters}
            />
          )
        ))}
      </Box>
    </Box>
  )
}

export default BiPage 